import styled from "styled-components";

const style = (Component) => styled(Component)``;

export default style;
